<template>

  <div class="content" v-loading="loading">

    <!--el-alert
      title="Enable two-factor authentication"
      type="warning"
      show-icon>
      <div>
        Currently two-factor authentication is off
      </div>
    </el-alert-->

    <el-row :gutter="8" class="filter-header">
      <el-col :span="14" class="text-right sort-container">

        Sort by
        <el-dropdown class="filter-dropdown" @command="changeSorting">
          <span class="el-dropdown-link">
            {{currentSorting}} <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="title">title</el-dropdown-item>
            <el-dropdown-item command="submissions">submissions</el-dropdown-item>
            <el-dropdown-item command="last activity">last activity</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </el-col>
      <el-col :span="7">

        <el-input
          placeholder="Search"
          prefix-icon="el-icon-search"
          @change="onSearch"
          v-model="searchText">
        </el-input>

      </el-col>
      <el-col :span="3">

        <el-button style="width: 100%" type="primary" @click="createForm">New form</el-button>

      </el-col>
    </el-row>

    <forms-list @form-settings="onFormSettings" />

    <el-dialog :title="(editedItem && editedItem._id) ? 'Form settings' : 'Create new form'" :visible.sync="showCreateForm">

      <settings-dialog :item="editedItem" />

    </el-dialog>
  </div>
</template>

<script>
import formsList from "components/formsList"
import SettingsDialog from "components/Forms/SettingsDialog"

const ITEM_TEMPLATE = {
  emails: [],
  options: {
    iconWidth: 70
  }
};

export default {
  components: {
    formsList,
    SettingsDialog
  },
  computed: {
    currentSorting() {
      return this.$store.state.formsSorting;
    },
    loading() {
      return this.$store.state.loading;
    },
    searchText: {
      get() {
        return this.$store.state.searchText;
      },
      set(val) {
        this.$store.state.searchText = val;
      }
    }
  },
  data() {
    return {
      editedItem: null,
      validate: null,
      showCreateForm: false
    }
  },
  methods: {
    changeSorting(command) {
      this.$store.state.formsSorting = command;
      this.$store.dispatch('loadForms');
    },
    async onSearch(item) {
      await this.$store.dispatch('loadForms');
    },
    async createForm() {
      this.editedItem = { ...ITEM_TEMPLATE };
      this.editedItem.account = { _id: this.$store.state.accountId };
      this.showCreateForm = true;
    },
    onFormSettings(item) {
      this.editedItem = item;
      this.showCreateForm = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// Forms.vue?a734b016